var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabRadiologyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .b {\n                fill: #2560a0;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12,1c6.07,0,11,4.93,11,11s-4.93,11-11,11S1,18.07,1,12,5.93,1,12,1m0-1C5.37,0,0,5.37,0,12s5.37,12,12,12,12-5.37,12-12S18.63,0,12,0h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.12,8.49l-2.02-3.5c-.25-.43-.81-.55-1.21-.26-1.93,1.41-3.27,3.59-3.53,6.1-.05,.49,.33,.92,.83,.92h4.04c.4,0,.72-.29,.81-.68,.14-.6,.46-1.13,.9-1.54,.3-.27,.39-.7,.19-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.9,4.99l-2.02,3.5c-.2,.35-.11,.77,.19,1.05,.44,.41,.76,.94,.9,1.54,.09,.39,.41,.68,.81,.68h4.04c.49,0,.88-.43,.83-.92-.27-2.5-1.6-4.69-3.53-6.1-.4-.29-.96-.17-1.21,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12,14.8c-.31,0-.61-.05-.89-.14-.38-.12-.79,.02-.99,.36l-2.02,3.5c-.25,.43-.07,.97,.38,1.17,1.08,.48,2.27,.75,3.53,.75s2.45-.27,3.53-.75c.45-.2,.62-.75,.38-1.17l-2.02-3.5c-.2-.35-.61-.48-.99-.36-.28,.09-.58,.14-.89,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.17,11.75c0,1.2-.97,2.17-2.17,2.17s-2.17-.97-2.17-2.17,.97-2.17,2.17-2.17,2.17,.97,2.17,2.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabRadiologyIcon);
export default __webpack_public_path__ + "static/media/TabRadiologyIcon.862894f7a69c05531d993fe02104aebf.svg";
export { ForwardRef as ReactComponent };